exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hs-search-highlight{color:#e74315;font-weight:700}", ""]);

// exports
